import { Heading, Icon } from "@abb/abb-common-ux-react";
import Grid from "@mui/material/Grid";
import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";
import { commonUXTheme } from "styles/commonUXVariables";
import { Card } from "./common/Card";
import PowerImage from "assets/PowerDistribution.PNG";
import { Box } from "@mui/system";
import { getApiRegistry } from "framework/state/apiRegistry";
import { Button } from "framework/components/Button";
import { SelectorSegmentDto, SelectorSubSegmentDto } from "api";
import { SubSegment } from "./common/SubSegment";

const CardIconContainer = styled(Grid)`
    margin:${(props) => props.theme.sizes.m};
`;

const CardIcon = styled.img`
   min-width:${(props) => props.theme.sizes.l};
   margin:auto;
`;

const CardTitleContainer = styled(Grid)`
    flex-grow:3;
    padding:5px;
`;

const Segment = styled(Card)`
    margin-top:${(props) => props.theme.sizes.xs};
    margin-bottom:${(props) => props.theme.sizes.xs};
    padding:${(props) => props.theme.sizes.m};

`;

const SegmentImage = styled.img`
    width: 100%
`;

interface SegmentStepProps {
    segments: SelectorSegmentDto[],
    subSegments: SubSegment[];
    onSegmentSelected: (segment?: SelectorSegmentDto) => void,
    selectedSubSegment?: SubSegment
}

const SegmentStep = ({ onSegmentSelected, selectedSubSegment, segments, subSegments: allSubSegments }: SegmentStepProps): JSX.Element => {
    const [filteredSubSegments, setFilteredSubSegments] = useState<SubSegment[]>([]);
    const [selectedSegment, setSelectedSegment] = useState<SelectorSegmentDto>();
    const { t } = useTranslation();

    useEffect(() => {
        if (selectedSegment && selectedSegment.selectorSubSegments)
            setFilteredSubSegments(selectedSegment.selectorSubSegments);
        else {
            if (allSubSegments)
                setFilteredSubSegments(allSubSegments);
        }
    }, [selectedSegment, allSubSegments]);

    const onSegmentClick = (segmentType?: SelectorSegmentDto) => {
        setSelectedSegment(segmentType);
    }

    const onSubSegmentClick = (subSegment?: SubSegment) => {
        if (subSegment?.image) {
            getApiRegistry().selectorApi.apiSelectorImagesImageNameGet({ imageName: subSegment.image }, { cache: "force-cache" }).then(file => {

                const reader = new FileReader();
                reader.readAsDataURL(file);
                reader.onloadend = function () {
                    subSegment.imageUrl = reader.result?.toString();
                    onSegmentSelected(subSegment);
                }
            });
        }
    }

    const segmentTypeButton = (segment: SelectorSegmentDto) => {
        const buttonType = segment && segment.id === selectedSegment?.id ? "primary-black" : "secondary";
        return <Button onClick={() => onSegmentClick(segment)} text={segment.name as string} buttonType={buttonType} />
    }

    const segmentsMidIndex = Math.ceil(filteredSubSegments.length / 2);

    return <>
        <Box width={"100%"} textAlign={"center"} mt={commonUXTheme.sizes.m} mb={commonUXTheme.sizes.m} >
            <Heading text={t("Select segment")} showCursor={false} level={3}></Heading>
        </Box>
        <Grid mb={commonUXTheme.sizes.m} container spacing={2} justifyContent={"center"} >
            {segments.map(s => s.name && <Grid key={s.id} item>{segmentTypeButton(s)} </Grid>)}
        </Grid>
        <Grid container spacing={2}  >
            <Grid item md={4} xs={6}  >
                {
                    filteredSubSegments.slice(0, segmentsMidIndex).map(s =>
                        <Segment key={s.name} container onClick={() => onSubSegmentClick(s)} selected={s.id === selectedSubSegment?.id}>
                            <CardIconContainer item >
                                <CardIcon src={s.pictogramUrl} />
                            </CardIconContainer>
                            <CardTitleContainer item ><h4>{s.name}</h4> </CardTitleContainer>
                        </Segment>)
                }
            </Grid>
            <Grid item md={4} xs={6}>
                {
                    filteredSubSegments.slice(segmentsMidIndex, filteredSubSegments.length).map(s =>
                        <Segment key={s.name} container onClick={() => onSubSegmentClick(s)} selected={s.id === selectedSubSegment?.id}>
                            <CardIconContainer item >
                                {/* <CardIcon sizeClass={"large"} name="abb/alarm-bell"></CardIcon> */}
                                <CardIcon src={s.pictogramUrl} />
                            </CardIconContainer>
                            <CardTitleContainer item ><h4>{s.name}</h4> </CardTitleContainer>
                        </Segment>)
                }
            </Grid>
            <Grid spacing={2} item container md={4} xs={12}>
                {selectedSubSegment &&
                    <>
                        <Grid item md={12} xs={6}>
                            <SegmentImage src={selectedSubSegment.imageUrl} />
                        </Grid>
                        <Grid item md={12} xs={6} >
                            {selectedSubSegment?.name && <Heading showCursor={false} text={selectedSubSegment.name} level={4}></Heading>}
                            <p>
                                {selectedSubSegment.description}
                            </p>
                        </Grid>

                    </>
                }
            </Grid>
        </Grid>
    </>
}

export default SegmentStep;
